const MarkdownIt = require('markdown-it');
const MarkdownItTocDoneRight = require('markdown-it-toc-done-right');
const MarkdownItAnchor = require('markdown-it-anchor');
const markdownItDeflist = require('markdown-it-deflist');

const md = function (parserType = 'ALL') {
	const parseHTML = parserType === 'ALL';

	// we zitten met wat es6 modules tegenover commonjs implementaties, voor nu kijken we gewoon of er een default functie aanwezig is, dan pakken we die en anders gewoon het ge-include object
	const md = new MarkdownIt({
		html: parseHTML,
		typographer: true,
		breaks: true
	})
		.use(
			MarkdownItTocDoneRight.default
				? MarkdownItTocDoneRight.default
				: MarkdownItTocDoneRight,
			{
				placeholder:
					'(\\$\\{toc\\}|\\[\\[?_?toc_?\\]?\\]|\\$\\<toc(\\{[^}]*\\})\\>|@\\[toc\\])',
				listType: 'ul',
				listClass: 'markdownIt-TOC',
				level: [2]
			}
		)
		.use(
			MarkdownItAnchor.default ? MarkdownItAnchor.default : MarkdownItAnchor,
			{
				level: [2]
			}
		)
		.use(markdownItDeflist);

	const defaultLinkOpenRender =
		md.renderer.rules.link_open ||
		function (tokens, idx, options, env, self) {
			return self.renderToken(tokens, idx, options);
		};

	md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
		if (typeof tokens[idx].attrIndex !== 'undefined') {
			const aIndex = tokens[idx].attrIndex('href');

			if (
				tokens[idx].attrs[aIndex][1].indexOf('https://www.wintersport.nl') !==
					0 &&
				tokens[idx].attrs[aIndex][1].substring(0, 1) !== '/' &&
				tokens[idx].attrs[aIndex][1].substring(0, 1) !== '#'
			) {
				tokens[idx].attrPush(['target', '_blank']);
				tokens[idx].attrPush(['rel', 'nofollow']);
			}
		}

		// pass token to default renderer.
		return defaultLinkOpenRender(tokens, idx, options, env, self);
	};

	md.renderer.rules.image = function (tokens, idx, _options, _env, _self) {
		const token = tokens[idx];
		let srcset = null;
		let sizes = null;
		let image = token.attrGet('src');

		if (
			(image.includes('cdn.wintersport.nl') ||
				image.includes('cdn.test.wintersport.nl')) &&
			!image.includes('width=')
		) {
			srcset = `srcset="${image}?width=400 400w, ${image}?width=600 600w, ${image}?width=920 920w"`;
			sizes = `sizes="(max-width: 400px) 400px, (max-width: 800px) 600px, 920px"`;
			image += '?width=920';
		}

		const attributes = [
			`src="${image}"`,
			srcset,
			sizes,
			`alt="${token.content || token.attrGet('title')}"`
		]
			.filter(attribute => !!attribute)
			.join(' ');

		return `<figure><a href="${token.attrGet(
			'src'
		)}" target="_blank" rel="nofollow"><img ${attributes} loading="lazy" /></a>${
			token.attrGet('title')
				? `<figcaption>${MarkdownIt().renderInline(
						token.attrGet('title')
				  )}</figcaption>`
				: ''
		}</figure>`;
	};

	// ENABLE OR DISABLE MARKDOWN RULES BASED ON PARSER TYPE
	if (parserType === 'ALL') {
		md.renderer.rules.infoblock_open = function (
			_tokens,
			_idx,
			_options,
			_env,
			_self
		) {
			return '<div class="floating-info">';
		};

		md.renderer.rules.infoblock_inline = function (
			tokens,
			idx,
			_options,
			_env,
			_self
		) {
			return md.renderInline(tokens[idx].content.substr(1).trim());
		};

		md.core.ruler.after('inline', 'infoblock', state => {
			for (let i = 0; i < state.tokens.length; i++) {
				const open = state.tokens[i];
				const inline = state.tokens[i + 1];
				const close = state.tokens[i + 2];

				if (open.type !== 'paragraph_open') continue;
				if (close.type !== 'paragraph_close') continue;
				if (!/^\^[ ]?(.*)/im.test(inline.content)) continue;

				open.type = 'infoblock_open';
				open.tag = 'div';

				inline.type = 'infoblock_inline';

				close.type = 'infoblock_close';
				close.tag = 'div';
			}
			return true;
		});
	}

	md.renderer.rules.quote_author_inline = function (
		tokens,
		idx,
		_options,
		_env,
		_self
	) {
		return tokens[idx].content.substr(1).trim();
	};

	md.core.ruler.after('inline', 'blockquote', state => {
		for (let i = 0; i < state.tokens.length; i++) {
			const open = state.tokens[i];
			const inline = state.tokens[i + 1];
			const close = state.tokens[i + 2];

			if (open.type !== 'paragraph_open') continue;
			if (close.type !== 'paragraph_close') continue;
			if (!/§[ ]?(.*)/i.test(inline.content)) continue;

			open.type = 'quote_author_open';
			open.tag = 'cite';

			inline.type = 'quote_author_inline';

			close.type = 'quote_author_close';
			close.tag = 'cite';
		}
		return true;
	});

	return md;
};

module.exports = { md };
